import React from 'react'

// importing components
import FBottom from './FooterSection2'

export default function FooterSection() {
    return (
        <div>
            <section className="footer-layout" id="footer">
                <FBottom/>
            </section>
        </div>
    )
}
